<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import 'moment-timezone';

export default {
  name: 'app',
};
</script>

<style lang="scss"></style>
